export enum NewsPriority {
  NORMAL= 'NORMAL',
  HIGH= 'HIGH'
}

export function newsPriorities() {
  return [NewsPriority.NORMAL, NewsPriority.HIGH];
}
